import { render, staticRenderFns } from "./ObjectDebugger.vue?vue&type=template&id=b18304f4&scoped=true&"
import script from "./ObjectDebugger.vue?vue&type=script&lang=ts&"
export * from "./ObjectDebugger.vue?vue&type=script&lang=ts&"
import style0 from "./ObjectDebugger.vue?vue&type=style&index=0&id=b18304f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18304f4",
  null
  
)

export default component.exports